module.exports = __webpack_public_path__ + "static/img/pass4.407aa94f.png";